import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15.553 18.664"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  class: "a",
  fill: "currentColor",
  d: "m15.525 15.916-.7-10.109a1.224 1.224 0 0 0-1.217-1.141h-1.36a.194.194 0 0 1-.194-.194v-.195a4.277 4.277 0 1 0-8.554 0v.194a.194.194 0 0 1-.194.194H1.944A1.224 1.224 0 0 0 .725 5.8l-.7 10.109q-.026.4-.026.806a1.944 1.944 0 0 0 1.944 1.944h11.666a1.944 1.944 0 0 0 1.944-1.944q0-.398-.028-.799ZM4.666 9.332a.778.778 0 1 1-.778.778.778.778 0 0 1 .778-.778Zm-.285 5.507a4.083 4.083 0 0 1 6.79 0 .583.583 0 1 1-.969.649 2.918 2.918 0 0 0-4.852 0 .583.583 0 1 1-.969-.649Zm6.506-3.952a.778.778 0 1 1 .778-.778.778.778 0 0 1-.778.778Zm-5.832-6.61a2.722 2.722 0 0 1 5.444 0v.194a.194.194 0 0 1-.194.194H5.249a.194.194 0 0 1-.194-.194Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }